import { Archivo, IBM_Plex_Mono, IBM_Plex_Sans, Inter } from 'next/font/google';

/**
 * Font landing page varian A "Gelap Premium" (Decision 33) — hanya dimuat di route `/`.
 *
 * Archivo dimuat sebagai font variabel dengan sumbu `wdth` (62–125) selain `wght`, supaya
 * potongan lebar (font-stretch 108–125%) seperti mockup benar-benar tersedia, bukan sintetis.
 * Catatan CSS: shorthand `font:` me-reset `font-stretch` → landing.module.css sengaja
 * memakai longhand untuk semua elemen Archivo.
 */
const fontDisplay = Archivo({
    subsets: ['latin'],
    axes: ['wdth'],
    variable: '--lp-display',
    display: 'swap',
});

const fontBody = IBM_Plex_Sans({
    subsets: ['latin'],
    weight: ['400', '500', '600'],
    variable: '--lp-body',
    display: 'swap',
});

const fontMono = IBM_Plex_Mono({
    subsets: ['latin'],
    weight: ['400', '500'],
    variable: '--lp-mono',
    display: 'swap',
});

/**
 * Font aplikasi MGMX (app/layout.tsx memakai Inter di <body>). Dipakai AppPreview di hero supaya
 * tampilan aplikasi asli tidak ikut font landing (.root → IBM Plex Sans).
 */
const fontApp = Inter({
    subsets: ['latin'],
    variable: '--lp-app',
    display: 'swap',
});

export const landingFontVars = `${fontDisplay.variable} ${fontBody.variable} ${fontMono.variable} ${fontApp.variable}`;
